module.exports = __webpack_public_path__ + "img/train-yellow.6b4cc5f0.svg";